<div class="secundary-header desktop">
  <div class="display-flex justify-between">
    <div>
      <div class="name-info display-flex">
        @if (name) {
          <div>
            <div class="name">
              <span>{{name}}</span>
            </div>
            @if (socialName) {
              <div class="social-name">
                <span>{{socialName}}</span>
              </div>
            }
            @if (listAllergyStruct && listAllergyStruct.length > 0) {
              <div (click)="openAllergies()">
                <button class="allergy">Alérgico</button>
              </div>
            }
          </div>
        }
        @if (!name) {
          <div>
            <div class="name-not-found">
              <span>Nenhum paciente chamado</span>
            </div>
          </div>
        }
      </div>
      <div class="display-flex">
        <div class="info-content">
          <div>
            <span class="text-bold">Nasc.:</span>
            <span class="padding-left-1">{{birthDate ? formatedBirth : '-'}}</span>
          </div>
          <div>
            <span class="text-bold">Idade:</span>
            <span class="padding-left-1">{{age ? age : '-'}}</span>
          </div>
          <div>
            <span class="text-bold">Linha de cuidado:</span>
            <span class="padding-left-1">{{patientCareLinePriorityStruct ?
              patientCareLinePriorityStruct.careLinePriorityName ?
              (patientCareLinePriorityStruct.careLinePriorityName + ' - ' +
            patientCareLinePriorityStruct.careLinePriorityStatusName ): '-' : '-'}} </span>
          </div>
        </div>
      </div>
    </div>
    @if (discriminators) {
      <div class="status-content display-flex">
        <div class="status-content__info">
          <span class="text-bold">Saturação</span>
          @if ((discriminators && discriminators[discriminatorTypeEnum.Saturacao])) {
            <span>{{discriminators
              && discriminators[discriminatorTypeEnum.Saturacao] ?
            discriminators[discriminatorTypeEnum.Saturacao]: '-'}}</span>
          }
          @if (discriminators && !discriminators[discriminatorTypeEnum.Saturacao]) {
            <span class="">-</span>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Glicemia</span>
          @if ((discriminators && discriminators[discriminatorTypeEnum.Glicemia])) {
            <span>{{discriminators
              && discriminators[discriminatorTypeEnum.Glicemia] ?
            discriminators[discriminatorTypeEnum.Glicemia] :'-'}}</span>
          }
          @if (discriminators && !discriminators[discriminatorTypeEnum.Glicemia]) {
            <span class="">-</span>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Pressão</span>
          @if ((discriminators && discriminators[discriminatorTypeEnum.PressaoArterial])) {
            <span>{{discriminators
              && discriminators[discriminatorTypeEnum.PressaoArterial] ?
            discriminators[discriminatorTypeEnum.PressaoArterial] :'-'}}</span>
          }
          @if (discriminators && !discriminators[discriminatorTypeEnum.PressaoArterial]) {
            <span class="">-</span>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Temperatura</span>
          @if ((discriminators && discriminators[discriminatorTypeEnum.Temperatura])) {
            <span>{{discriminators
              && discriminators[discriminatorTypeEnum.Temperatura] ?
            discriminators[discriminatorTypeEnum.Temperatura] :'-'}}</span>
          }
          @if (discriminators && !discriminators[discriminatorTypeEnum.Temperatura]) {
            <span class="">-</span>
          }
        </div>
        <div class="status-content__info">
          <span class="text-bold">Pulso</span>
          @if ((discriminators && discriminators[discriminatorTypeEnum.FrequenciaCardiaca])) {
            <span
              >{{discriminators
              && discriminators[discriminatorTypeEnum.FrequenciaCardiaca] ?
            discriminators[discriminatorTypeEnum.FrequenciaCardiaca] : '-'}}</span>
          }
          @if (discriminators && !discriminators[discriminatorTypeEnum.FrequenciaCardiaca]) {
            <span
            class="">-</span>
          }
        </div>
        <div>
          @if (isClassification) {
            <a mat-flat-button matTooltip="Reiniciar medidores"
              (click)="emitMeasurerRestart()" type="button" color="accent" class="btn-block">
              <mat-icon class="reload-icon">sync</mat-icon>
            </a>
          }
        </div>
      </div>
    }
  </div>
</div>
<cdk-accordion class="accordion mobile">
  <cdk-accordion-item #accordionItem="cdkAccordionItem" class="accordion-item" role="button" tabindex="0"
    [attr.id]="'accordion-header'" [attr.aria-expanded]="accordionItem.expanded"
    [attr.aria-controls]="'accordion-body'">
    <div [ngClass]="{'accordion-item-header-expanded': accordionItem.expanded}" class="accordion-item-header"
      (click)="accordionItem.toggle()">
      <div class="name-info display-flex">
        @if (name) {
          <div>
            <div class="name truncate">
              <span>{{name}}</span>
            </div>
            @if (socialName) {
              <div class="social-name truncate">
                <span>{{socialName}}</span>
              </div>
            }
            @if (listAllergyStruct && listAllergyStruct.length > 0) {
              <div (click)="openAllergies()">
                <button class="allergy">Alérgico</button>
              </div>
            }
          </div>
        }
        @if (!name) {
          <div>
            <div class="name-not-found">
              <span>Nenhum paciente chamado</span>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="accordion-item-body" role="region" [style.display]="accordionItem.expanded ? '' : 'none'"
      [attr.id]="'accordion-body'" [attr.aria-labelledby]="'accordion-header'">
      <div class="info-content">
        <div class="line-height">
          <span class="text-bold">Nasc.:</span>
          <span class="padding-left-1">{{birthDate ? formatedBirth : '-'}}</span>
        </div>
        <div class="line-height">
          <span class="text-bold">Idade:</span>
          <span class="padding-left-1">{{age ? age : '-'}}</span>
        </div>
      </div>
    </div>
  </cdk-accordion-item>
</cdk-accordion>